const FooterComponent = () => (
    <footer className="bg-gray-900 border-t border-white/10 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div>
                    <h3 className="text-3xl font-black tracking-tighter mb-4 justify-items-center">
                        {/*<span className="text-orange-500">Cage</span><span className="text-white">EEG</span>*/}
                        <img style={{marginTop: "-50px", marginBottom: "-50px" }}  alt={"CageEEG LOGO"} src={"/cageeeg_nobg.png"} width={200} height={100} />
                    </h3>
                    <p className="text-gray-400">
                        Open source rozwiązania EEG dla nauki, rozrywki i pasjonatów
                    </p>
                </div>

                <div>
                    <h4 className="font-semibold text-white mb-4">Projekt</h4>
                    <ul className="space-y-2">
                        <li><a href="https://github.com/cageeeg/cageeeg"
                               className="text-gray-400 hover:text-orange-500 transition-colors">GitHub</a></li>
                        <li><a href="/docs"
                               className="text-gray-400 hover:text-orange-500 transition-colors">Dokumentacja</a></li>
                        <li><a href="/roadmap"
                               className="text-gray-400 hover:text-orange-500 transition-colors">Roadmapa</a></li>
                        {/*<li><a href="/contributors"*/}
                        {/*       className="text-gray-400 hover:text-orange-500 transition-colors">Kontrybutorzy</a></li>*/}
                    </ul>
                </div>

                <div>
                    <h4 className="font-semibold text-white mb-4">Społeczność</h4>
                    <ul className="space-y-2">
                        <li><a href="/discord"
                               className="text-gray-400 hover:text-orange-500 transition-colors">Discord</a></li>
                        {/*<li><a href="/forum" className="text-gray-400 hover:text-orange-500 transition-colors">Forum</a>*/}
                        {/*</li>*/}
                        {/*<li><a href="/blog" className="text-gray-400 hover:text-orange-500 transition-colors">Blog</a>*/}
                        {/*</li>*/}
                        {/*<li><a href="/newsletter"*/}
                        {/*       className="text-gray-400 hover:text-orange-500 transition-colors">Newsletter</a></li>*/}
                    </ul>
                </div>

                <div>
                    <h4 className="font-semibold text-white mb-4">Informacje prawne</h4>
                    <ul className="space-y-2">
                        <li><a href="/privacy" className="text-gray-400 hover:text-orange-500 transition-colors">Polityka
                            prywatności</a></li>
                        {/*<li><a href="/terms"*/}
                        {/*       className="text-gray-400 hover:text-orange-500 transition-colors">Regulamin</a></li>*/}
                        {/*<li><a href="/license" className="text-gray-400 hover:text-orange-500 transition-colors">Licencja*/}
                        {/*    MIT</a></li>*/}
                        {/*<li><a href="/security"*/}
                        {/*       className="text-gray-400 hover:text-orange-500 transition-colors">Security</a></li>*/}
                    </ul>
                </div>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-400">
                <p>&copy; 2025 CageEEG Open Source Project. Wszystkie prawa zastrzeżone.</p>
                {/*<p className="mt-2 text-sm">Wydane na licencji MIT</p>*/}
            </div>
        </div>
    </footer>
)

export default FooterComponent
